export const parseHlsToken = (response: { token: string }) => response.token;
